import React, { useEffect, useState } from 'react';

const ToggleComplaintData = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastDayPrevMonth, setLastDayPrevMonth] = useState('');

  useEffect(() => {
    // Function to get the last day of previous month with proper suffix
    const getLastDayOfPreviousMonth = (baseDate = new Date()) => {
      const lastDay = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0); // 0 = last day of previous month
      const day = lastDay.getDate();
      const month = lastDay.toLocaleString('default', { month: 'long' });
      const year = lastDay.getFullYear();

      let suffix = 'th';
      if (day % 10 === 1 && day !== 11) suffix = 'st';
      else if (day % 10 === 2 && day !== 12) suffix = 'nd';
      else if (day % 10 === 3 && day !== 13) suffix = 'rd';

      return `${day}${suffix} ${month} ${year}`;
    };

    setLastDayPrevMonth(getLastDayOfPreviousMonth());
  }, []);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="w-full mx-auto">
      {!isVisible ? (
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 bg-gray-50 p-4 rounded-lg shadow-sm">
          <h2 className="text-[#113262] font-medium text-bold text-l md:text-xl lg:text-2xl">Complaint Data Of RIA</h2>
          <button 
            onClick={toggleVisibility}
            className="inline-flex items-center px-4 py-2 bg-[#1C52A0] text-white rounded-md hover:bg-[#113262] transition duration-300"
          >
            Click Here
          </button>
        </div>
      ) : (
        <div className="relative bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <button 
            onClick={toggleVisibility}
            className="absolute top-3 right-3 p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition duration-300"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10 lg:py-12">
            <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Complaint Data Of RIA
            </h2>
            
            <div className="mb-10">
              <h3 className="text-center text-xl md:text-2xl my-6 text-gray-700">
                Number of complaints (As of <span>{lastDayPrevMonth}</span>)*
              </h3>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse mb-5">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 font-semibold text-center">At the beginning of the month</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Pending at the end of last month</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Received during the month</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Resolved during the month</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Pending at the end of the month</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Reasons for pendency</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="mb-10">
              <h3 className="text-center text-xl md:text-2xl my-6 text-gray-700">
                Number Of Complaints For The Last Year
              </h3>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse mb-5">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 font-semibold text-center">At the beginning of the year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Pending at the end of year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Received during the year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Resolved during the year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Pending at the end of the year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Reasons for pendency</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">3</td>
                      <td className="border border-gray-300 p-3 text-center">3</td>
                      <td className="border border-gray-300 p-3 text-center">0</td>
                      <td className="border border-gray-300 p-3 text-center">-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="mb-10">
              <h3 className="text-center text-xl md:text-2xl my-6 text-gray-700">
                Complaints Data for the Last 4 Years
              </h3>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse mb-5">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 font-semibold text-center">Sr. No.</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Financial Year</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Compliance Audit Status</th>
                      <th className="border border-gray-300 p-3 font-semibold text-center">Remarks If Any</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">1</td>
                      <td className="border border-gray-300 p-3 text-center">FY 2023-2024</td>
                      <td className="border border-gray-300 p-3 text-center">Conducted</td>
                      <td className="border border-gray-300 p-3 text-center"></td>
                    </tr>
                    <tr className="hover:bg-gray-50 bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">2</td>
                      <td className="border border-gray-300 p-3 text-center">FY 2022-2023</td>
                      <td className="border border-gray-300 p-3 text-center">Conducted</td>
                      <td className="border border-gray-300 p-3 text-center"></td>
                    </tr>
                    <tr className="hover:bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">3</td>
                      <td className="border border-gray-300 p-3 text-center">FY 2021-2022</td>
                      <td className="border border-gray-300 p-3 text-center">Conducted</td>
                      <td className="border border-gray-300 p-3 text-center"></td>
                    </tr>
                    <tr className="hover:bg-gray-50 bg-gray-50">
                      <td className="border border-gray-300 p-3 text-center">4</td>
                      <td className="border border-gray-300 p-3 text-center">FY 2020-2021</td>
                      <td className="border border-gray-300 p-3 text-center">Conducted</td>
                      <td className="border border-gray-300 p-3 text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="text-left mt-5 text-base">
              <p>
                For Complaint data of RIA – INA200015583,{' '}
                <a 
                  href={`https://jamaappprod.s3.ap-south-1.amazonaws.com/compliants_data/RIA%2BCompliants%2BData.pdf?cb=${Date.now()}`}
                   
                  className="text-blue-600 hover:underline"
                >
                  click here
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ToggleComplaintData;